"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetInTouch() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="get-in-touch" ref={ref} className="w-full bg-primary py-20 md:py-28" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(1rem)",
    transition: "opacity 150ms ease-out, transform 150ms ease-out"
  }}>
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center text-center">
          <h2 className="font-display text-3xl font-bold text-foreground-primary sm:text-4xl md:text-5xl">
            Get In Touch
          </h2>
          <p className="mt-4 max-w-2xl text-base text-foreground-primary/90 sm:text-lg md:text-xl">
            Ready to start your next project? Contact B&B VETERANS LLC today and experience the quality you deserve.
          </p>
          <p className="mt-8 text-lg font-semibold text-foreground-primary sm:text-xl">
            Call to get your quote started
          </p>
        </div>
      </div>
    </section>;
}